import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SigningSessionStateService } from '@app/services/signing-session-state.service';
import { ToastService } from '@app/services/toast.service';
import { SigningSessionUtil } from '@app/utilities/signing-session-util';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-signing-session-bar',
  templateUrl: './signing-session-bar.component.html',
  styleUrl: './signing-session-bar.component.scss',
})
export class SigningSessionBarComponent implements OnInit {
  readonly state = inject(SigningSessionStateService);
  private readonly translate = inject(TranslateService);
  private readonly toast = inject(ToastService);

  readonly confirmOpen = signal(false);
  readonly ending = signal(false);

  readonly clock = computed(() => SigningSessionUtil.formatClock(this.state.elapsedSeconds()));
  readonly expiry = computed(() => SigningSessionUtil.formatClock(this.state.secondsUntilExpiry()));

  ngOnInit(): void {
    this.state.ensureLoaded();
  }

  requestEnd(event: Event): void {
    event.preventDefault();
    this.confirmOpen.set(true);
  }

  confirmEnd(): void {
    this.ending.set(true);
    this.state
      .close()
      .pipe(finalize(() => this.ending.set(false)))
      .subscribe({
        next: () => {
          this.confirmOpen.set(false);
          this.toast.success(this.translate.instant('Common_Success'), this.translate.instant('Signing_End_Success'));
        },
        error: (error) => this.toast.error(this.translate.instant('Signing_Error_Title'), this.state.messageFrom(error)),
      });
  }
}
